export default "__VITE_ASSET__CeMG0vwE__"